import { useSelector } from 'react-redux';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { getBrand } from '@/redux/brand';
import { getUser } from '@/redux/user';

export const useLaunchdarkly = (): {
    getFeatureFlagByContext: (flag: string, context: Record<string, unknown>) => Promise<boolean>;
} => {
    const user = useSelector(getUser);
    const currentBrand = useSelector(getBrand);
    const ldClient = useLDClient();

    const getFeatureFlagByContext = async (flag: string, context: Record<string, unknown>): Promise<boolean> => {
        if (!user || !ldClient) return false;
        const { firstName, lastName, email, userId, brandId, restaurants, role } = user;

        await ldClient.identify({
            key: userId.toString(),
            firstName,
            lastName,
            email,
            custom: {
                role,
                restaurantId: restaurants[0].restaurantId,
                ...(brandId !== null ? { brandId } : {}),
                ...(currentBrand && currentBrand.brandType ? { brandType: currentBrand.brandType } : {}),
                ...context,
            },
        });
        const flags = await ldClient.allFlags();
        return !!flags[flag];
    };

    return { getFeatureFlagByContext };
};
